/**
 * SmartDropdownFormHook
 *
 * Handles form submission for the SmartUserDropdown "Add New User" modal.
 * This hook collects input values and sends them to the LiveView component.
 */
export default {
  mounted() {
    console.log('SmartDropdownFormHook mounted on:', this.el);

    // Find the submit button by class/role since ID changes per dropdown
    const submitButton = this.el.querySelector('button[phx-click="create_and_select_user"]');

    if (!submitButton) {
      console.error('Submit button not found in modal');
      return;
    }

    console.log('Found submit button:', submitButton);

    // Get dropdown ID from the container
    const dropdownId = this.el.id.replace('-add-modal', '');
    console.log('Dropdown ID:', dropdownId);

    // Store original click handler
    const originalClick = submitButton.getAttribute('phx-click');
    const originalTarget = submitButton.getAttribute('phx-target');

    // Remove phx-click to prevent default LiveView handling
    submitButton.removeAttribute('phx-click');

    // Add our custom click handler
    submitButton.addEventListener('click', (e) => {
      console.log('Submit button clicked');
      e.preventDefault();
      e.stopPropagation();

      // Collect values from inputs
      const firstName = document.getElementById(`${dropdownId}-first-name`)?.value;
      const lastName = document.getElementById(`${dropdownId}-last-name`)?.value;
      const phone = document.getElementById(`${dropdownId}-phone`)?.value;
      const email = document.getElementById(`${dropdownId}-email`)?.value || '';

      console.log('Collected values:', { firstName, lastName, phone, email });

      // Validate required fields
      if (!firstName || !lastName || !phone) {
        alert('Please fill in all required fields (First Name, Last Name, Phone)');
        return;
      }

      // Get other params from button attributes
      const fieldName = submitButton.getAttribute('phx-value-field-name');
      const roleType = submitButton.getAttribute('phx-value-role-type');

      // Build params object
      const params = {
        dropdown_id: dropdownId,
        field_name: fieldName,
        role_type: roleType,
        new_user: {
          first_name: firstName,
          last_name: lastName,
          phone: phone,
          email: email
        }
      };

      console.log('Pushing create_and_select_user with params:', params);

      // Push to the target component
      if (originalTarget) {
        this.pushEventTo(originalTarget, 'create_and_select_user', params);
      } else {
        this.pushEvent('create_and_select_user', params);
      }
    });
  }
};
